import client from '../httpClient';

const directTupdateApi = (directId, params) => {
  return client.post(`/directs/timeline/${directId}`, params, { isShowLoading: false });
};

export default directTupdateApi;
